import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-user-found',
    templateUrl: './user-found.component.html',
    styleUrls: ['./user-found.component.scss'],
})
export class UserFoundComponent implements OnInit {
    @Input() user: any;
    @Input() selection: boolean;
    @Output() select: EventEmitter<any> = new EventEmitter();

    selected;

    constructor() {}

    ngOnInit(): void {}
}
